<template>
  <div class="mb-5">
    <b-navbar
      class="mt-3 navbar-wrapper"
      type="light"
      variant="faded"
      toggleable="md"
    >
      <b-navbar-brand href="/">
        <img
          width="150px"
          src="../assets/logo-klaus-rebrand.svg"
          alt="Logo da Klaus"
        />
      </b-navbar-brand>
      <b-navbar-toggle class="btn-menu mt-2" target="nav-collapse">
        <svg
          class="mr-2"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style="fill: #2c3e50; transform: ; -ms-filter: "
        >
          <path d="M4 6H20V8H4zM4 11H20V13H4zM4 16H20V18H4z"></path></svg
        >MENU
      </b-navbar-toggle>

      <b-collapse class="navegacao" id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item
            target="_blank"
            href="https://klausfiscal.com.br/faq/"
            class="text-dark mr-lg-5"
          >
            ajuda
          </b-nav-item>
          <b-nav-item
            target="_blank"
            href="https://klausfiscal.com.br/blog/"
            class="mr-lg-5 text-dark"
          >
            blog
          </b-nav-item>
          <b-nav-item
            target="_blank"
            href="https://klausfiscal.com.br/"
            class="mr-lg-5 text-dark"
          >
            site da Klaus Fiscal
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style scoped>
.navegacao a:hover {
  color: #007fff !important;
}

.navbar-wrapper {
  width: 90vw;
  margin: 0 auto;
}

.navbar-collapse.show {
  margin-top: 10px;
  background: #03283f;
  border-radius: 5px;
  padding: 15px 0;
}

.navbar-collapse.show a {
  padding: 15px 5px;
  color: white !important;
}

.btn-menu {
  overflow-anchor: none;
  border: none;
  letter-spacing: 2px;
  font-size: 1rem;
}
</style>